import { omit } from 'util/objects'
import { BOOTSTRAP_APP_DATA_SUCCESS } from 'constants/action_types'

import {
  FETCH_INTEGRATIONS_SUCCESS,
  REMOVE_INTEGRATION_STARTED,
  REMOVE_INTEGRATION_SUCCESS,
  UPDATE_INTEGRATION_CREDENTIALS_RESPONSE,
  REMOVE_INTEGRATION_BY_PROVIDER_SUCCESS,
} from '../../types'

const defaultState = {}
export default function byIdReducer(
  state = defaultState,
  { meta: { integrationId } = {}, payload = {}, type }
) {
  const integrations = payload.integrations || {}
  const nodes = integrations.nodes || []

  if (
    type === FETCH_INTEGRATIONS_SUCCESS ||
    type === BOOTSTRAP_APP_DATA_SUCCESS
  ) {
    return nodes.reduce((result, integration) => {
      // eslint-disable-next-line no-param-reassign
      result[integration.id] = {
        ...integration,
        meta: {},
      }
      return result
    }, {})
  }

  if (type === REMOVE_INTEGRATION_SUCCESS) return omit([integrationId], state)
  if (type === REMOVE_INTEGRATION_BY_PROVIDER_SUCCESS)
    return omit(payload, state)

  if (type === UPDATE_INTEGRATION_CREDENTIALS_RESPONSE) {
    return {
      ...state,
      [integrationId]: {
        ...payload,
        meta: {},
      },
    }
  }

  if (type === REMOVE_INTEGRATION_STARTED) {
    return {
      ...state,
      [integrationId]: {
        ...state[integrationId],
        meta: {
          ...state[integrationId].meta,
          removing: true,
        },
      },
    }
  }

  return state
}
